import { render, staticRenderFns } from "./FarmacieEditComponent.vue?vue&type=template&id=72e2bbe0"
import script from "./FarmacieEditComponent.vue?vue&type=script&lang=js"
export * from "./FarmacieEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports